
const digest = 'f109dd4d649d8a46b540b0678c0b56c72f49fb23e080962bc4e88e4b14cefe72';
const classes = {"caseTakeOverWrapper":"_caseTakeOverWrapper_14qwy_1","text":"_text_14qwy_13","noAccessMessage":"_noAccessMessage_14qwy_18"};
const css = `._caseTakeOverWrapper_14qwy_1 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #eaedf3;
  border-radius: 5px;
  font-family: Rubik, sans-serif;
  padding: 24px;
  gap: 20px;
  background-color: #ffffff;
}
._caseTakeOverWrapper_14qwy_1 ._text_14qwy_13 {
  font-size: 14px;
  text-align: center;
}

._noAccessMessage_14qwy_18 {
  font-size: 14px;
  text-align: center;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 24px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  